import { reject, isEmpty } from 'ramda';

import Vue from 'vue';
import Vuex from 'vuex';
import { getField, updateField } from 'vuex-map-fields';

import api from '../../common/config/apiAxiosInstance';

import i18n from '../../lib/i18n';

Vue.use(Vuex);

/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */

// initial state
const state = {
  filterType: null,
  filterKind: null,
  events: [],
  loadingError: false,
  loadingErrorMessage: '',
  currentPage: 0,
  totalPages: 0,
  filterState: {
    field_id: '',
    course_id: '',
    place: '',
    date: '',
  },
  filterAttributes: {},
  beforeInitialFetch: true,
};

// getters
const getterMethods = {
  getField,
  getFilterField(state) {
    return getField(state.filterState);
  },
  allEvents: state => state.events,
  showMoreEvents: state => state.currentPage < state.totalPages,
  getHeaders: state => ({
    headers: {
      'X-localization': i18n.locale,
      'X-filter-type': state.filterType,
      'X-filter-kind': state.filterKind,
    },
  }),
};

// actions
const actions = {
  fetchFilterAttributes({ commit, getters }) {
    api.get('closest_events/filter_attributes.json', getters.getHeaders)
      .then((response) => {
        commit('setAttributes', response.data);
      })
      .catch((error) => { commit('setError', 'Something went wrong'); });
  },
  loadFirstPageEvents({ commit, getters }) {
    const filterParams = reject(isEmpty, state.filterState);

    api.get('closest_events.json', { params: { event: filterParams }, ...getters.getHeaders })
      .then((response) => {
        commit('setEventsData', response.data);
        commit('setBeforeInitialFetch', false);
      })
      .catch((error) => { commit('setError', 'Something went wrong'); });
  },
  loadNextPageEvents({ commit, getters }) {
    const page = state.currentPage + 1;
    const filterParams = reject(isEmpty, state.filterState);

    api.get('closest_events.json', { params: { page, event: filterParams }, ...getters.getHeaders })
      .then((response) => {
        commit('addEventsData', response.data);
      })
      .catch((error) => { commit('setError', 'Something went wrong'); });
  },
  setFilterType({ commit }, type) {
    commit('setFilterType', type);
  },
  setFilterKind({ commit }, kind) {
    commit('setFilterKind', kind);
  },

};

// mutations
const mutations = {
  updateField,
  updateFilterField(state, field) {
    updateField(state.filterState, field);
    this.dispatch('loadFirstPageEvents');
  },
  setAttributes(state, attributes) {
    state.filterAttributes = attributes;
  },
  setBeforeInitialFetch(state, value) {
    state.beforeInitialFetch = value;
  },
  setEventsData(state, payload) {
    state.events = payload.closest_events;
    state.currentPage = payload.current_page;
    state.totalPages = payload.total_pages;
  },
  addEventsData(state, payload) {
    state.events = [...state.events, ...payload.closest_events];
    state.currentPage = payload.current_page;
    state.totalPages = payload.total_pages;
  },
  setError(state, errorMessage) {
    state.loadingError = true;
    state.loadingErrorMessage = errorMessage;
  },
  setFilterType(state, type) {
    state.filterType = type;
  },
  setFilterKind(state, kind) {
    state.filterKind = kind;
  },
};

const store = new Vuex.Store({
  state,
  getters: getterMethods,
  actions,
  mutations,
});

export default store;
